import { commonMessages } from 'src/utils/messages';
import { useIntl } from 'react-intl';

export const GetDurationFromMinutes = (totalMinutes: number) => {
    const { formatMessage } = useIntl();

    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    return (
        [
            days > 0 && formatMessage(commonMessages.days, { value: days }),
            hours > 0 && formatMessage(commonMessages.hours, { value: hours }),
            minutes > 0 && formatMessage(commonMessages.minutes, { value: minutes }),
        ]
            .filter(Boolean)
            .join(' ') || formatMessage(commonMessages.minutes, { value: 0 })
    );
};
